import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AutomationKey, AutomationSetting, UpdateAutomationInput } from '@peles/shared';
import { listAutomationRuns, listAutomations, updateAutomation } from '../api/automations';

export const AUTOMATIONS_KEY = ['automations'] as const;
const RUNS_KEY = [...AUTOMATIONS_KEY, 'runs'] as const;

export function useAutomations() {
  return useQuery({ queryKey: AUTOMATIONS_KEY, queryFn: listAutomations });
}

export function useAutomationRuns() {
  return useQuery({ queryKey: RUNS_KEY, queryFn: () => listAutomationRuns() });
}

export function useUpdateAutomation() {
  const queryClient = useQueryClient();
  return useMutation<
    AutomationSetting,
    Error,
    { key: AutomationKey; input: UpdateAutomationInput }
  >({
    mutationFn: ({ key, input }) => updateAutomation(key, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AUTOMATIONS_KEY }),
  });
}
